import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

let currentToken = null;
export function setAuthToken(token) {
  currentToken = token;
  if (token) {
    localStorage.setItem("sc_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("sc_token");
    delete api.defaults.headers.common["Authorization"];
  }
}

// Restore on load
const stored = typeof window !== "undefined" ? localStorage.getItem("sc_token") : null;
if (stored) {
  currentToken = stored;
  api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;
}

export function getAuthToken() {
  return currentToken;
}

// Duplicate payment guard: backend replies 409 {code:"duplicate_payment"} → ask, then resend with confirm.
api.interceptors.response.use(undefined, async (error) => {
  const d = error?.response?.data?.detail;
  const cfg = error?.config;
  if (error?.response?.status === 409 && d?.code === "duplicate_payment" && cfg && !cfg.__dupRetried) {
    if (window.confirm(d.msg || "Yeh payment abhi save hua hai. Phir bhi dobara add karein?")) {
      const body = typeof cfg.data === "string" ? JSON.parse(cfg.data || "{}") : (cfg.data || {});
      return api.request({ ...cfg, __dupRetried: true, data: { ...body, confirm_duplicate: true } });
    }
    error.response.data.detail = "Duplicate payment cancel kiya gaya";
  }
  return Promise.reject(error);
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
